import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-accent-400 text-xs font-medium mb-4">
            <i className="ri-grid-line text-sm"></i>
            分类浏览
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
            按分类探索<strong className="text-accent-500">黑料</strong>
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            六大分类板块，覆盖社会热点领域的<strong>黑料曝光</strong>与<strong>内幕揭秘</strong>
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative h-48 md:h-56 rounded-lg overflow-hidden cursor-pointer"
            >
              {/* Background Image */}
              <img
                src={cat.image}
                alt={`51黑料网 - ${cat.name}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                title={`${cat.name} - 51黑料网`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/40 to-transparent"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-500/20 text-accent-400">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <h3 className="text-base font-semibold text-foreground-50">{cat.name}</h3>
                </div>
                <p className="text-xs text-foreground-400 mb-1">{cat.description}</p>
                <span className="text-xs text-foreground-500">{cat.count} 篇曝光</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}